export const ALERT_SNACK_BAR_ACTION = "ALERT_SNACK_BAR_ACTION";
export const CLOSE_SNACK_BAR_ACTION = "CLOSE_SNACK_BAR_ACTION";

export const USER_LOGOUT = "USER_LOGOUT";

export const RESET_ACTION = "RESET_ACTION";

export const RESUME_PARSER_ACTION = "RESUME_PARSER_ACTION";
export const RESUME_PARSER_ACTION_FAIL = "RESUME_PARSER_ACTION_FAIL";

export const SAVE_USER_ACTION = "SAVE_USER_ACTION";
export const SAVE_USER_ACTION_FAIL = "SAVE_USER_ACTION_FAIL";

export const GET_CANDIDATES_ACTION = "GET_CANDIDATES_ACTION";
export const RESET_CANDIDATES_ACTION = "RESET_CANDIDATES_ACTION";
export const GET_CANDIDATES_SEARCH_ACTION_SUCCESS =
  "GET_CANDIDATES_SEARCH_ACTION_SUCCESS";
export const GET_CANDIDATES_ACTION_FAIL = "GET_CANDIDATES_ACTION_FAIL";

export const GET_CANDIDATES_SEARCH_ACTION = "GET_CANDIDATES_SEARCH_ACTION";
export const GET_CANDIDATES_SEARCH_ACTION_FAIL =
  "GET_CANDIDATES_SEARCH_ACTION_FAIL";

export const SELECTED_CANDIDATE_ACTION = "SELECTED_CANDIDATE_ACTION";

export const GET_CANDIDATE_DETAIL_ACTION = "GET_CANDIDATE_DETAIL_ACTION";
export const GET_CANDIDATE_DETAIL_ACTION_FAIL =
  "GET_CANDIDATE_DETAIL_ACTION_FAIL";
export const GET_CANDIDATE_DETAIL_LOADING_ACTION =
  "GET_CANDIDATE_DETAIL_LOADING_ACTION";

export const GET_USER_SUBMISSIONS_ACTION = "GET_USER_SUBMISSIONS_ACTION";
export const GET_USER_SUBMISSIONS_ACTION_FAIL =
  "GET_USER_SUBMISSIONS_ACTION_FAIL";

export const GET_CANDIDATE_SUBMISSIONS_ACTION =
  "GET_CANDIDATE_SUBMISSIONS_ACTION";
export const GET_CANDIDATE_SUBMISSIONS_ACTION_FAIL =
  "GET_CANDIDATE_SUBMISSIONS_ACTION_FAIL";

export const GET_SOLR_JOBS_LOADING_ACTION = "GET_SOLR_JOBS_LOADING_ACTION";
export const GET_SOLR_JOBS_ACTION = "GET_SOLR_JOBS_ACTION";
export const GET_SOLR_JOBS_ACTION_FAIL = "GET_SOLR_JOBS_ACTION_FAIL";

export const GET_LATEST_SOLR_JOBS_ACTION = "GET_LATEST_SOLR_JOBS_ACTION";
export const GET_LATEST_SOLR_JOBS_ACTION_FAIL =
  "GET_LATEST_SOLR_JOBS_ACTION_FAIL";

export const GET_SUBMISSIONS_TYPES_ACTION = "GET_SUBMISSIONS_TYPES_ACTION";
export const GET_SUBMISSIONS_TYPES_ACTION_FAIL =
  "GET_SUBMISSIONS_TYPES_ACTION_FAIL";

export const GET_CANDIDATE_RESUME_ACTION = "GET_CANDIDATE_RESUME_ACTION";
export const GET_CANDIDATE_RESUME_ACTION_FAIL =
  "GET_CANDIDATE_RESUME_ACTION_FAIL";

export const GET_CANDIDATE_DOCUMENTS_ACTION = "GET_CANDIDATE_DOCUMENTS_ACTION";
export const GET_CANDIDATE_DOCUMENTS_ACTION_FAIL =
  "GET_CANDIDATE_DOCUMENTS_ACTION_FAIL";

export const GET_JOB_DETAILS_REQUEST = "GET_JOB_DETAILS_REQUEST";
export const GET_JOB_DETAILS_ACTION = "GET_JOB_DETAILS_ACTION";
export const GET_JOB_DETAILS_ACTION_FAIL = "GET_JOB_DETAILS_ACTION_FAIL";

export const SELECTED_JOB_ACTION = "SELECTED_JOB_ACTION";

export const GET_SUBMISSIONS_ACTION = "GET_SUBMISSIONS_ACTION";
export const GET_SUBMISSIONS_ACTION_FAIL = "GET_SUBMISSIONS_ACTION_FAIL";

export const SEND_JOB_TO_CANDIDATE_ACTION = "SEND_JOB_TO_CANDIDATE_ACTION";
export const SEND_JOB_TO_CANDIDATE_ACTION_FAIL =
  "SEND_JOB_TO_CANDIDATE_ACTION_FAIL";

export const UPDATE_SUBMISSIONS_ACTION = "UPDATE_SUBMISSIONS_ACTION";
export const UPDATE_SUBMISSIONS_ACTION_FAIL = "UPDATE_SUBMISSIONS_ACTION_FAIL";

export const SEND_PROFILE_TO_VENDOR = "SEND_PROFILE_TO_VENDOR";
export const SEND_PROFILE_TO_VENDOR_FAIL = "SEND_PROFILE_TO_VENDOR_FAIL";

export const RATE_CONFIRMATION_ACTION = "RATE_CONFIRMATION_ACTION";
export const RATE_CONFIRMATION_ACTION_FAIL = "RATE_CONFIRMATION_ACTION_FAIL";

export const SELECTED_SUBMISSION_ACTION = "SELECTED_SUBMISSION_ACTION";

export const INTERVIEW_SCHEDULE_ACTION = "INTERVIEW_SCHEDULE_ACTION";
export const INTERVIEW_SCHEDULE_ACTION_FAIL = "INTERVIEW_SCHEDULE_ACTION_FAIL";

export const UPDATE_INTERVIEW_SCHEDULE_ACTION =
  "UPDATE_INTERVIEW_SCHEDULE_ACTION";
export const UPDATE_INTERVIEW_SCHEDULE_ACTION_FAIL =
  "UPDATE_INTERVIEW_SCHEDULE_ACTION_FAIL";

export const ADD_CANDIDATE_ACTION = "ADD_CANDIDATE_ACTION";
export const ADD_CANDIDATE_ACTION_FAIL = "ADD_CANDIDATE_ACTION_FAIL";

export const UPDATE_CANDIDATE_ACTION = "UPDATE_CANDIDATE_ACTION";
export const UPDATE_CANDIDATE_ACTION_FAIL = "UPDATE_CANDIDATE_ACTION_FAIL";

export const GET_STATES_ACTION = "GET_STATES_ACTION";
export const GET_STATES_ACTION_FAIL = "GET_STATES_ACTION_FAIL";

export const GET_CITIES_ACTION = "GET_CITIES_ACTION";
export const GET_CITIES_ACTION_FAIL = "GET_CITIES_ACTION_FAIL";

export const GET_JOBTYPES_ACTION = "GET_JOBTYPES_ACTION";
export const GET_JOBTYPES_ACTION_FAIL = "GET_JOBTYPES_ACTION_FAIL";

export const GET_COUNTRIES_ACTION = "GET_COUNTRIES_ACTION";
export const GET_COUNTRIES_ACTION_FAIL = "GET_COUNTRIES_ACTION_FAIL";

export const UPLOAD_DOCUMENTS_ACTION = "UPLOAD_DOCUMENTS_ACTION";
export const UPLOAD_DOCUMENTS_ACTION_FAIL = "UPLOAD_DOCUMENTS_ACTION_FAIL";

export const GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION =
  "GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION";
export const GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION_FAIL =
  "GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION_FAIL";

export const OPEN_RIGHT_PANEL_ACTION = "OPEN_RIGHT_PANEL_ACTION";

export const SHARE_PROFILE_ACTION = "SHARE_PROFILE_ACTION";
export const SHARE_PROFILE_ACTION_FAIL = "SHARE_PROFILE_ACTION_FAIL";

export const GET_ZIPCODES_ACTION = "GET_ZIPCODES_ACTION";
export const GET_ZIPCODES_ACTION_FAIL = "GET_ZIPCODES_ACTION_FAIL";

export const VMAIL_SIGNUP_ACTION = "VMAIL_SIGNUP_ACTION";
export const VMAIL_SIGNUP_ACTION_FAIL = "VMAIL_SIGNUP_ACTION_FAIL";

export const VMAIL_SIGNIN_ACTION = "VMAIL_SIGNUP_ACTION";
export const VMAIL_SIGNIN_ACTION_FAIL = "VMAIL_SIGNUP_ACTION_FAIL";

export const GET_ACTIVE_CANDIDATES_LOADING_ACTION = "GET_ACTIVE_CANDIDATES_LOADING_ACTION"
export const GET_ACTIVE_CANDIDATES_ACTION = "GET_ACTIVE_CANDIDATES_ACTION";
export const GET_ACTIVE_CANDIDATES_ACTION_FAIL =
  "GET_ACTIVE_CANDIDATES_ACTION_FAIL";

export const GET_INACTIVE_CANDIDATES_ACTION = "GET_INACTIVE_CANDIDATES_ACTION";
export const GET_INACTIVE_CANDIDATES_ACTION_FAIL =
  "GET_INACTIVE_CANDIDATES_ACTION_FAIL";

export const UPDATE_CANDIDATE_STATUS_ACTION = "UPDATE_CANDIDATE_STATUS_ACTION";
export const UPDATE_CANDIDATE_STATUS_ACTION_FAIL =
  "UPDATE_CANDIDATE_STATUS_ACTION_FAIL";

export const GET_SOURCES_LOADING_ACTION = "GET_SOURCES_LOADING_ACTION";
export const GET_SOURCES_ACTION = "GET_SOURCES_ACTION";
export const GET_SOURCES_ACTION_FAIL = "GET_SOURCES_ACTION_FAIL";

export const SELECTED_SOURCE_ACTION = "SELECTED_SOURCE_ACTION";

export const JOB_INTERESTED_STATUS_ACTION = "JOB_INTERESTED_STATUS_ACTION";
export const JOB_INTERESTED_STATUS_ACTION_FAIL =
  "JOB_INTERESTED_STATUS_ACTION_FAIL";

export const GET_INTERESTED_JOB_ACTION = "GET_INTERESTED_JOB_ACTION";
export const GET_INTERESTED_JOB_ACTION_FAIL = "GET_INTERESTED_JOB_ACTION_FAIL";

export const CANDIDATE_LOGIN_ACTION = "CANDIDATE_LOGIN_ACTION";
export const CANDIDATE_LOGIN_ACTION_FAIL = "CANDIDATE_LOGIN_ACTION_FAIL";

export const UPDATE_PRIMARY_RESUME_ACTION = "UPDATE_PRIMARY_RESUME_ACTION";
export const UPDATE_PRIMARY_RESUME_ACTION_FAIL =
  "UPDATE_PRIMARY_RESUME_ACTION_FAIL";

export const GET_PRIMARY_RESUME_DETAILS_ACTION =
  "GET_PRIMARY_RESUME_DETAILS_ACTION";
export const GET_PRIMARY_RESUME_DETAILS_LOADING_ACTION =
  "GET_PRIMARY_RESUME_DETAILS_LOADING_ACTION";
export const GET_PRIMARY_RESUME_DETAILS_ACTION_FAIL =
  "GET_PRIMARY_RESUME_DETAILS_ACTION_FAIL";

export const GET_RECRUITER_INTERESTED_CANDIDATES_ACTION =
  "GET_RECRUITER_INTERESTED_CANDIDATES_ACTION";
export const GET_RECRUITER_INTERESTED_CANDIDATES_ACTION_FAIL =
  "GET_RECRUITER_INTERESTED_CANDIDATES_ACTION_FAIL";

export const CREATE_NOTIFICATION_ACTION = "CREATE_NOTIFICATION_ACTION";
export const CREATE_NOTIFICATION_ACTION_FAIL =
  "CREATE_NOTIFICATION_ACTION_FAIL";

export const GET_MY_ACTIVE_RECRUITERS_ACTION =
  "GET_MY_ACTIVE_RECRUITERS_ACTION";
export const GET_MY_ACTIVE_RECRUITERS_ACTION_FAIL =
  "GET_MY_ACTIVE_RECRUITERS_ACTION_FAIL";
export const GET_MY_ACTIVE_RECRUITERS_LOADING = "GET_MY_ACTIVE_RECRUITERS_LOADING";


export const ADD_OR_EDIT_RECRUITER_ACTION = "ADD_OR_EDIT_RECRUITER_ACTION";
export const ADD_OR_EDIT_RECRUITER_ACTION_FAIL =
  "ADD_OR_EDIT_RECRUITER_ACTION_FAIL";

export const GET_CANDIDATES_RESUMES_LIST_ACTION =
  "GET_CANDIDATES_RESUMES_LIST_ACTION";
export const GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL =
  "GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL";

export const CANDIDATE_SELECTED_RESUME_ACTION =
  "CANDIDATE_SELECTED_RESUME_ACTION";
export const CANDIDATE_SELECTED_RESUME_ACTION_FAIL =
  "CANDIDATE_SELECTED_RESUME_ACTION_FAIL";

export const ASSIGN_CANDIDATES_TO_RECRUITERS_ACTION =
  "ASSIGN_CANDIDATES_TO_RECRUITERS_ACTION";
export const ASSIGN_CANDIDATES_TO_RECRUITERS_ACTION_FAIL =
  "ASSIGN_CANDIDATES_TO_RECRUITERS_ACTION_FAIL";

export const SELECTED_RECRUITER_ACTION = "SELECTED_RECRUITER_ACTION";
export const SELECTED_RECRUITER_ACTION_FAIL = "SELECTED_RECRUITER_ACTION_FAIL";

export const GET_ASSIGNED_CANDIDATES_ACTION = "GET_ASSIGNED_CANDIDATES_ACTION";
export const GET_ASSIGNED_CANDIDATES_ACTION_FAIL =
  "GET_ASSIGNED_CANDIDATES_ACTION_FAIL";

export const UPDATE_ADMIN_ACCESS_ACTION = "UPDATE_ADMIN_ACCESS_ACTION";
export const UPDATE_ADMIN_ACCESS_ACTION_FAIL =
  "UPDATE_ADMIN_ACCESS_ACTION_FAIL";

export const REMOVE_ASSIGNED_CANDIDATES_ACTION =
  "REMOVE_ASSIGNED_CANDIDATES_ACTION";
export const REMOVE_ASSIGNED_CANDIDATES_ACTION_FAIL =
  "REMOVE_ASSIGNED_CANDIDATES_ACTION_FAIL";

export const UPDATE_RECRUITER_STATUS_ACTION = "UPDATE_RECRUITER_STATUS_ACTION";
export const UPDATE_RECRUITER_STATUS_ACTION_FAIL =
  "UPDATE_RECRUITER_STATUS_ACTION_FAIL";

export const GET_INACTIVE_RECRUITERS_ACTION = "GET_INACTIVE_RECRUITERS_ACTION";
export const GET_INACTIVE_RECRUITERS_ACTION_FAIL =
  "GET_INACTIVE_RECRUITERS_ACTION_FAIL";

export const DELETE_RESUME_ACTION = "DELETE_RESUME_ACTION";
export const DELETE_RESUME_ACTION_FAIL = "DELETE_RESUME_ACTION_FAIL";

export const CANDIDATE_ROLE_BASED_JOB_REPORTS =
  "CANDIDATE_ROLE_BASED_JOB_REPORTS";
export const CANDIDATE_ROLE_BASED_JOB_REPORTS_FAIL =
  "CANDIDATE_ROLE_BASED_JOB_REPORTS_FAIL";

export const GET_INTERESTED_JOB_LIST_ACTION = "GET_INTERESTED_JOB_LIST_ACTION";
export const GET_INTERESTED_JOB_LIST_ACTION_FAIL =
  "GET_INTERESTED_JOB_LIST_ACTION_FAIL";

export const GET_JOBS_COUNT_ACTION = "GET_JOBS_COUNT_ACTION";
export const GET_JOBS_COUNT_ACTION_FAIL = "GET_JOBS_COUNT_ACTION_FAIL";

export const GET_CANDIDATE_JOBDETAILS_ACTION =
  "GET_CANDIDATE_JOBDETAILS_ACTION";
export const GET_CANDIDATE_JOBDETAILS_ACTION_FAIL =
  "GET_CANDIDATE_JOBDETAILS_ACTION_FAIL";

export const GET_JOBTYPE_FILTERED_IDS_ACTION =
  "GET_JOBTYPE_FILTERED_IDS_ACTION";
export const GET_JOBTYPE_FILTERED_IDS_ACTION_FAIL =
  "GET_JOBTYPE_FILTERED_IDS_ACTION_FAIL";

export const REMOVE_JOBTYPE_FILTER_ACTION = "REMOVE_JOBTYPE_FILTER_ACTION";

export const GET_JOBS_FROM_DB_ACTION = "GET_JOBS_FROM_DB_ACTION";
export const GET_JOBS_FROM_DB_FAIL_ACTION = "GET_JOBS_FROM_DB_FAIL_ACTION";

export const RECRUITERS_ACTIVITY_ACTION = "RECRUITERS_ACTIVITY_ACTION";

export const RECRUITERS_ACTIVITY_ACTION_FAIL =
  "RECRUITERS_ACTIVITY_ACTION_FAIL";

export const VMAIL_TOKEN_ACTION = ""

export const GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP =
  "GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP";
export const GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP_LOADING_ACTION =
  "GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP_LOADING_ACTION";

export const GET_COMPANY_PACKAGE_DATA_ACTION = "GET_COMPANY_PACKAGE_DATA_ACTION";
export const GET_COMPANY_PACKAGE_DATA_ACTION_FAIL = "GET_COMPANY_PACKAGE_DATA_ACTION_FAIL";

export const UPDATE_PACKAGE_ALERT_LOG_ACTION = "UPDATE_PACKAGE_ALERT_LOG_ACTION";
export const UPDATE_PACKAGE_ALERT_LOG_ACTION_FAIL = "UPDATE_PACKAGE_ALERT_LOG_ACTION_FAIL";

